/* eslint-disable react-refresh/only-export-components */

import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { fetchCompanyProfile } from '@/api/companies';
import { QuestionnaireTab } from '@/app/(client)/network/-components/companyProfileTabs/questionnaire/QuestionnaireTab';
import { queryClient } from '@/lib/utils/queryClient';
import { useSessionStore } from '@/store/sessionStore';

const searchSchema = z.object({
  blueprint: z.string().optional(),
});

export const Route = createFileRoute(
  '/(client)/network/(pages)/(detail)/$companyId/questionnaire',
)({
  validateSearch: searchSchema,
  beforeLoad: async ({ params }) => {
    const company = await queryClient.ensureQueryData({
      queryKey: ['network', 'company', params.companyId],
      queryFn: () => fetchCompanyProfile(params.companyId),
    });
    const user = useSessionStore.getState().user;
    const isOwnCompany =
      user?.companyId === (company?.forCompanyId ?? params.companyId);
    if (isOwnCompany) {
      throw redirect({
        to: '/network/$companyId/general-info',
        params: { companyId: params.companyId },
      });
    }
  },
  component: QuestionnaireRoute,
});

function QuestionnaireRoute() {
  const { companyId } = Route.useParams();
  return <QuestionnaireTab companyId={companyId} />;
}
